import { useCallback, useEffect, useState } from "react";
import { useClerk } from "@clerk/react";
import { ShieldAlert } from "lucide-react";
import { useApi, twofa } from "../lib/api";
import { Button } from "./ui/button";
import TwoFASetup from "./TwoFASetup";
import TwoFAVerify from "./TwoFAVerify";

const Denied = () => {
  const { signOut } = useClerk();
  return (
    <div className="auth-screen" data-testid="access-denied">
      <div className="card max-w-md text-center">
        <ShieldAlert className="mx-auto mb-4 text-rose-400" size={40} />
        <h1 className="font-heading text-2xl font-bold">Acesso negado</h1>
        <p className="mt-2 text-sm text-slate-400">Esta conta não é o administrador da Gateway. A tentativa foi registrada no log de segurança.</p>
        <Button className="btn-ghost mt-6" onClick={() => signOut()} data-testid="denied-signout-button">Sair</Button>
      </div>
    </div>
  );
};

export default function TwoFAGate({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [denied, setDenied] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      if (!data.twofa_valid) twofa.clear();
      setMe(data);
    } catch (e) {
      if (e.response?.status === 403) setDenied(true);
    }
  }, [api]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const h = () => setMe((m) => (m ? { ...m, twofa_valid: false } : m));
    window.addEventListener("2fa-expired", h);
    return () => window.removeEventListener("2fa-expired", h);
  }, []);

  const done = (token) => { twofa.set(token); setMe((m) => ({ ...m, totp_enabled: true, twofa_valid: true })); };

  if (denied) return <Denied />;
  if (!me) return <div className="auth-screen"><div className="loader" data-testid="gate-loading" /></div>;
  if (!me.totp_enabled) return <TwoFASetup email={me.email} onDone={done} />;
  if (!me.twofa_valid) return <TwoFAVerify email={me.email} onDone={done} />;
  return children(me);
}
